import {
  TextBody2,
  TextBody3,
  TextNote1,
  textStyleButton2,
} from "common/components";
import styled from "styled-components";
import { PopoverTrigger } from "../popover";
import { Column, Row } from "common/components/Layout/new/constLayout";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { I18N_KEYS } from "common/i18n/keys";

export const CalendarCellWithPopover = ({
  date,
  style,
  onSelect,
  allowSelect,
  scheduleDetail,
}) => {
  const { t } = useTranslation();
  const canShowPopover = true;
  const day = date.getDate();

  const popoverContent = useMemo(() => {
    return scheduleDetail?.details?.map((detail, index) => (
      <Column gap="0.5rem" key={index}>
        <Row gap="0.25rem" $align={"center"}>
          <TextBody3>{detail.courseName}</TextBody3>
          <TextNote1>
            (
            {detail.status === "ACTIVE"
              ? t(I18N_KEYS.common.active)
              : t(I18N_KEYS.common.inactive)}
            )
          </TextNote1>
        </Row>
        <TextBody2>
          {detail.teeTimeName &&
            detail.priceName &&
            `${detail.teeTimeName} / ${detail.priceName}`}
        </TextBody2>
      </Column>
    ));
  }, [scheduleDetail]);

  return (
    <PopoverTrigger
      popoverContent={popoverContent}
      isShowPopover={canShowPopover}>
      <CalendarCell
        key={`day-${day}`}
        onClick={() => {
          if (!allowSelect) return;
          onSelect?.(date);
        }}
        style={style}>
        {day}
      </CalendarCell>
    </PopoverTrigger>
  );
};

export const CalendarCell = styled.div`
  ${textStyleButton2}
  text-align: center;
  cursor: pointer;
  min-height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;
